<template>
  <div id="machine">
  <!-- 面包线导航 -->
    <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>机器人管理</el-breadcrumb-item>
        <el-breadcrumb-item>机器人设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card >
        <!-- 第一行筛选框 -->
        <el-row :gutter="20">
                <!-- 机器名查询 -->
                <el-col :span="5" >
                    <el-input placeholder="请输入编号" v-model="robotInfo.robotNo" class="m-l-30 ell-input" ></el-input>
                </el-col>
                <!-- 机器地址查询 -->
                <el-col :span="5">
                    <el-input placeholder="请输入机器名称" v-model="robotInfo.robotName" class="m-l-30 ell-input" ></el-input>
                </el-col>
                <!-- 设备是否在线 -->
                <el-col :span="5">
                   <el-select v-model="robotInfo.status" placeholder="请选择机器状态" class="m-l-30">
                        <el-option v-for="item in robotStatus" :key="item.value"  :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
                 <!-- 设备是否在线 -->
                <el-col :span="5">
                    <el-select v-model="robotInfo.robotType" placeholder="请选择机器类型" class="m-l-30">
                            <el-option v-for="item in robotTypes" :key="item.value"  :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                </el-col>
               
        </el-row>
        <!-- 第二行筛选框 -->
        <el-row :gutter="20" >
            <el-col align="middle" >
                <el-button type="primary" @click="searchRobot()">查询</el-button>
                <el-button type="info" @click="clearParamsRobotInfo()">重置</el-button>
            </el-col>   
        </el-row>
        <!-- 用户列表区域 -->
        <el-table :data="robotList" border  stripe  :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column label="机器编号" prop="robotNo" width="400"></el-table-column>
            <el-table-column label="机器名称" prop="robotName" width="180"></el-table-column>
            <el-table-column label="机器类型"  width="80">
                  <template   slot-scope="scope">
                    <span v-if="scope.row.robotType==='2'"  >
                        安保
                    </span>
                    <span v-if="scope.row.robotType==='1'" >
                        消杀
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="开启时间" prop="startTime" width="180"></el-table-column>
            <el-table-column label="离线时间" prop="offlineTime" width="180"></el-table-column>
            <el-table-column label="状态"  width="70">
                <template   slot-scope="scope">
                    <span v-if="scope.row.status==='0'"  >
                        离线
                    </span>
                    <span v-if="scope.row.status==='1'" style="color:blue" >
                        在线
                    </span>
                    <span v-if="scope.row.status==='10'" style="color:blue" >
                        升级中
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="电量%" prop="eleQuantity"  width="70"></el-table-column>
            <el-table-column label="操作" prop="" width="450">
                <template slot-scope="scope">
                    <!-- 获取机器本机日志 -->
                    <el-tooltip effect="dark" content="本地日志" placement="top" :enterable="false" >
                        <el-button type="primary" size="mini" @click="jumpLog(scope.row)">日志文件下载</el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="工作日志" placement="top" :enterable="false" >
                        <el-button type="info" size="mini" @click="jumpWorkLog(scope.row)">工作日志</el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="维修记录" placement="top" :enterable="false" >
                        <el-button type="danger" size="mini" @click="repairLog(scope.row)">维修记录</el-button>
                    </el-tooltip>
                     <!-- 地图编辑 -->
                    <el-tooltip effect="dark" content="管理" placement="top" :enterable="false" >
                        <el-button type="primary" size="mini"  @click="taskDialog(scope.row)">管理</el-button>
                    </el-tooltip>
                  
                </template>
            </el-table-column>
        </el-table>
         <!-- 分页区间 -->
        <el-pagination   @current-change="handleCurrentChange"  :current-page.sync="robotInfo.num"  
                :page-size="10"  layout="total, prev, pager, next"  :total="total">
        </el-pagination>
      <!--地图编辑-->
      <el-dialog  :visible.sync="dialogTaskVisible" class="taskdialog" @close="taskDialogClose"  >
        <el-row>
            <el-form ref="addPlan" :model="addPlan">
            <span style="font-size:25px">请选择场景:</span>
            <el-select v-model="addPlan.sceneSelected" placeholder="请选择需要编辑的地图" style="width:42%" @change="changeSceneSelected">
                <el-option v-for="dict in scenes" :key="dict.id" :label="dict.mapNo" :value="dict.id"   />
            </el-select>
            <span style="font-size:25px;color:blue;float:right;padding-right:100px">使用场景: {{this.userMapNo}}</span>
            <h1>计划编辑:</h1>
            <el-table :data="addPlan.planList" border style="width:100%" fit>
                <el-table-column prop="id" label="计划编号" />
                <el-table-column prop="type" label="任务模式">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type=='1'">循环任务</span>
                        <span v-if="scope.row.type=='2'">定时任务</span>
                    </template>
                </el-table-column>
                <el-table-column prop="value" label="计划时间" />
                <el-table-column prop="startTime" label="任务开始时间" />
                <el-table-column prop="endTime" label="任务结束时间" />
            </el-table>
            <el-form-item label="星期选择" style="margin-top: 20px" label-width="80px">
                <el-checkbox v-model="addPlan.checkAll" :indeterminate="addPlan.isIndeterminate"  @change="handleCheckAllChange">全选</el-checkbox>
                <el-checkbox-group v-model="addPlan.checkedWeekes" @change="handleCheckedWeekesChange">
                    <el-checkbox v-for="(week,index) in addPlan.labels" :key="index" :label="week">{{ week }}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="起始时间" label-width="80px">
                <el-time-picker v-model="addPlan.startAndend" is-range range-separator="至" start-placeholder="开始时间" 
                 end-placeholder="结束时间" placeholder="选择时间范围" value-format="HH:mm" format='HH:mm' @change="changestartAndend" />
            </el-form-item>
            <el-form-item label="计划类型" label-width="80px">
                <el-select v-model="addPlan.type" placeholder="请选择计划类型" style="width:42%" @change="selectplanType">
                    <el-option label="循环执行" value="1" />
                    <el-option label="定时任务" value="2" />
                </el-select>
            </el-form-item>
            <el-form-item v-show="addPlan.showSplitTime" label="间隔时长" label-width="80px">
                <el-select v-model="addPlan.timeId" placeholder="请选择时长" style="width:42%">
                    <el-option v-for="item in addPlan.planSplitTime" :key="item.timeId" :label="item.label" :value="item.timeId" :disabled="item.disabled" />
                </el-select>
            </el-form-item>
            <el-form-item v-show="addPlan.showMTime" label="选择时段" label-width="80px">
                <el-col :span="11">
                    <el-time-picker v-model="addPlan.selectValueStr" type="fixed-time" placeholder="选择时间" :picker-options="addPlan.selectTimeRange" value-format="HH:mm" format='HH:mm' style="width:91%"  />
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" style="width:80px" vertical-align="middle" @click="addTimeClick()">添加</el-button>
                </el-col>
            </el-form-item>
            <el-form-item v-show="addPlan.showMTime" label="任务时段" label-width="80px">
                <el-col :span="11">
                    <el-input v-model="addPlan.valueStr" type="textarea" style="width:91%" :disabled="true" />
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" style="width:80px" vertical-align="middle" @click="reduceTimeClick()">删除</el-button>
                </el-col>
            </el-form-item>
        </el-form>
        </el-row> 
        <el-row>
            <h1>任务编辑:</h1>
            <el-form ref="addTask" :model="addTask">
                <el-table :data="addTask.taskList" width="100%" height="200" border  :row-style="{height:'25px'}" :cell-style="{padding:'0px'}" style="width:100%" fit >
                    <el-table-column prop="taskId" label="任务编号" width="80" />
                    <el-table-column prop="goalName" label="目标点名称" width="80" />
                    <el-table-column prop="type" label="任务类型" width="120">
                        <template slot-scope="scope">
                            <span v-if="scope.row.type=='0'">行走命令</span>
                            <span v-if="scope.row.type=='1'">目标点</span>
                            <span v-if="scope.row.type=='3'">执行消杀</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="goalId" label="目标点" width="80">
                            <template slot-scope="scope">
                                <span v-if="scope.row.goalId  == -1">--</span>
                                <span v-if="scope.row.goalId  != -1"> {{ scope.row.goalId }}</span>
                            </template>
                    </el-table-column>
                    <el-table-column prop="type" label="任务内容">
                            <template slot-scope="scope">
                                <span v-if="scope.row.type=='0'">开始行走</span>
                                <span v-if="scope.row.type=='1'">目标点选定</span>
                                <span v-if="scope.row.type=='3'"> 消杀{{ scope.row.workTime }}秒</span>
                            </template>
                    </el-table-column>
                    <el-table-column label="操作" width="80">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="deleteTaskClick(scope.row)">删除</el-button>
                            </template>
                    </el-table-column>
                </el-table>
                <el-row :gutter='20'>
                    <el-col :span="9">
                            <el-form-item label="任务类型" style="margin-top: 20px" label-width="80px" class="el-row">
                                <el-select v-model="addTask.type" placeholder="请选择任务类型" style="width:100%" @change="selectTaskType">
                                <el-option label="设置任务点" value="1" />
                                <el-option label="执行消杀" value="3" />
                                </el-select>
                            </el-form-item>
                            <el-form-item v-show="addTask.showGoal" label="目标名称" label-width="80px" class="el-row">
                                <el-input v-model="addTask.goalName" placeholder="请输入目标名称" style="width:100%" />
                            </el-form-item>
                            <el-form-item v-show="addTask.showGoal" label="目标点" label-width="80px" class="el-row">
                                <el-input v-model="addTask.goalId" disabled style="width:100%" />
                            </el-form-item>
                            <el-form-item v-show="addTask.showGoal" label="角度" label-width="80px" class="el-row">
                                <el-input v-model="addTask.goalYaw" disabled style="width:100%" />
                            </el-form-item>
                            <el-form-item v-show="addTask.showMTime" label="选择时长(s)" label-width="95px" class="el-row">
                                <el-select v-model="addTask.timeId" placeholder="请选择时长" style="width:100%">
                                <el-option v-for="item in addTask.taskSplitTime" :key="item.timeId" :label="item.label" :value="item.timeId" :disabled="item.disabled" />
                                </el-select>
                            </el-form-item>
                             <el-button v-show="addTask.showAddButton" type="primary" style="margin-left:71%;width:100px" @click="addTaskItemClick()">添加</el-button>
                        </el-col>              
                        <el-col :span="14">
                            <canvas id="mycanvas" class="mycanvasDiv" alt="" style="margin-top: 20px;height: auto;width: 100%;" />
                        </el-col>
                </el-row>
            </el-form>
        </el-row>
        <el-row>
            <el-col :span="16" :push="18">
                <el-button type="primary" style="width:100px" @click="commitPlanAndTaskClick()">保存编辑</el-button>
            </el-col>
            <el-col :span="4" :push="5" v-if="tempRobot.status==1">
                <el-button type="primary" style="width:100px" @click="usePlanAndTasks()">下发任务</el-button>
            </el-col>
            <el-col :span="4" :push="5" v-if="tempRobot.status==0">
                <el-button type="primary" style="width:100px" @click="usePlanAndTasks()" disabled>下发任务</el-button>
            </el-col>
        </el-row>
      </el-dialog>
      <!-- 上传日志进度条  -->
      <el-dialog title="上传中"  :visible.sync="dialogProgressVisible" class="taskdialog" @close="progressDialogClose"  >
          <el-progress :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>
      </el-dialog>
      <!--下发任务进度条 -->
      <el-dialog title="下发任务中"  :visible.sync="dialogProgressTaskVisible" class="taskdialog" :showClose="false" @close="progressTaskDialogClose">
          <el-progress type="circle" :percentage="taskPercentage" :status="progressStatus"></el-progress>
      </el-dialog>
    </el-card >
  </div>
</template>

<script>
const weekOptions = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期天']
import mqtt from 'mqtt'
import { MQTT_SERVICE, MQTT_USERNAME } from './sysconstant'
import { mapState } from 'vuex'
export default {
  name: 'missionPlanning',
  data(){
      return {
          robotInfo :{
              robotNo:'',
              robotName:'',
              status:'',
              pageNum : 1
          },
          addTask:{
               scenes: [],
               sceneSelected:'',
               taskList:[],
               type:'',
               showGoal:false,
               showMTime:'',
               goalName:'',
               goalId:'-1',
               goalYaw:'',
               timeId:'',
               mapPngUrl:'',
               roadUrl:'',
               orginUrl:'',
               clickdown:false,
               taskSplitTime: [{ timeId: 0, label: '1' }, { timeId: 1, label: '5' }, { timeId: 2, label: '15' }, { timeId: 3, label: '30' }, { timeId: 4, label: '45' }, { timeId: 5, label: '60' }, { timeId: 6, label: '75' }, { timeId: 7, label: '90' }, { timeId: 8, label: '120' }],
               drawingSufraceData: null,
               angle:'',
               showAddButton:false
          },
          dialogProgressVisible:false,
          dialogProgressTaskVisible:false,
          //场景
          scenes:[],
          addPlan: {
            planList: [],
            //range: ["00:00:00","23:59:59"],
            sceneSelected: '',
            startAndend:["00:00:00","23:59:59"],
            selectValueStr: '',
            selectTimeRange: {},
            textarea: '',
            type: '',
            robot_number: '',
            showSplitTime: false,
            showMTime: false,
            labels: weekOptions,
            checkAll: false,
            isIndeterminate: false,
            allElection: [],
            selectionArr: [],
            checkedWeekes: '',
            timeId: '',
            valueStr:'',
            planSplitTime: [{ timeId: 1, label: '1' }, { timeId: 5, label: '5' }, { timeId: 15, label: '15' }, { timeId: 30, label: '30' }, { timeId: 45, label: '45' }, { timeId: 60, label: '60' }, { timeId:75, label: '75' }, { timeId: 90, label: '90' }, { timeId: 120, label: '120' }],
            timeIntervals: []
          },
          total:0,
          robotStatus:[
             {
                value: '0',
                label: '离线'
            }, {
                value: '1',
                label: '在线'
            }
          ],
          dialogPlanVisible:false,
          dialogTaskVisible:false,
          robotTypes:[
             {
                value: '1',
                label: '消杀'
            },{
                value: '2',
                label: '安保'
            }
          ],
          robotList:[],
          editRobotNo:'',
          scene:'',
          taskScene:'',
          newplan:{
              id:'',
              robotNo:'',
              type:'',
              mapId:'',
              startTime:'',
              endTime:'',
              week:'',
              value:''
          },
          resolution:'',
          origin_x:'',
          origin_y:'',
          lineList:'',
          dotList:'',
          imageWidth: '',
          imageHeight: '',
          gcanvas: null,
          timer:'',
          taskTimer:'',
          percentage:10,
          taskPercentage:10,
          topic:'',
          client:null,
          tempRobot:'',
          progressStatus:null,
          commitPlanFlag:false,
          userMapNo:'',
      }
  },
   computed: mapState([
    // 映射 this.count 为 store.state.count
    'mqttClient'
   ]),
   //生命周期函数
  created(){
      this.connectMqtt();
    //   setInterval(()=>{
    //       this.localReload()}
    //       ,6000000);
  },

  beforeRouteLeave(to, form, next) {
        if(this.mqttClient!=='' && this.mqttClient!==null){
            this.unsubscribe()
        } 
        next()
  },
  methods:{
        //跳转机器人日志页面
        jumpLog(obj){
            this.$router.replace({path: '/robotlog?robotNo='+obj.robotNo+"&status="+obj.status+'&pageFlag='+"1"})
        },
        jumpWorkLog(obj){
            this.$router.replace({path: '/workWarn?robotNo='+obj.robotNo+'&pageFlag='+"1"});
        },
        repairLog(obj){ 
            this.$router.replace({path: '/repair?robotNo='+obj.robotNo+'&pageFlag='+"1"})
        },
        connectMqtt(){
             if(this.mqttClient==null){
                //启动vuex初始化方法
                this.$store.dispatch('mqttServer')
                let that=this
                setTimeout(function() {
                      that.init();
                      that.searchRobot();
                    }, 1000)
             }else{
                this.init();
                this.searchRobot();
             }    
        },
        init(){
            var topic="/Unione/CommandReply/#"
            this.topic=topic;
            try {
                this.mqttClient.subscribe(topic, { qos: 0 }, (error) => {
                        window.sessionStorage.setItem("subscribe",0)
                        console.log('连接成功'+topic)
                        if (!error) {
                        console.log('订阅成功')
                        } else {
                        console.log('订阅失败')
                        }
                })
            } catch (e) {
                var subscribe=window.sessionStorage.getItem('subscribe')
                if(subscribe*1===1){
                    this.$message.error("网络差,退出重新登录!");
                    return this.$router.push('/login') 

                }else{
                    window.sessionStorage.setItem("subscribe",1)
                    this.$store.dispatch('mqttServer')
                    location.reload()
                    return 
                }
            }

            let that=this
            // 接收消息处理
            this.mqttClient.on('message', (tcp, message) => {
                let Topic =tcp
                if(!Topic.endsWith(that.editRobotNo)){
                    return
                }
                var data =JSON.parse(message)
                //日志上传
                if(that.dialogProgressVisible &&  data.type=='2'){
                   if(data.code=="1"){
                        that.$message.error(data.detail);
                   }else{
                        that.percentage=100
                   }
                   var t
                    clearTimeout(t)
                    t = setTimeout(function() {
                        that.progressDialogClose()
                    }, 1000)
                   
                }
                //任务下发
                if(that.dialogProgressTaskVisible &&  data.type=='3'){
                   if(data.code==1){
                        that.$message.error(data.detail);
                        that.progressStatus="exception"
                   }else if((data.code==0)){
                        that.$message.success(data.detail);
                        that.taskPercentage=100
                        that.progressStatus="success"
                        //更新地图
                        that.$http.get('robot/updateRobotMapNo',{params :{ robotNo :  that.editRobotNo,mapNo :  that.scene.mapNo}}) .then(response => {
                        if (response.data.code === 200) {
                              return that.userMapNo=that.scene.mapNo;
                            }
                        })
                   }
                    var t
                    clearTimeout(t)
                    t = setTimeout(function() {
                      that.progressTaskDialogClose()
                    }, 100)
                   
                }
            })
        },
        unsubscribe: function() {  
            this.mqttClient.unsubscribe(  
                    this.topic, err => {  
                    console.log(err || '取消订阅成功');  
                }  
            );  
        },  
        uploadLog(obj){
            if(obj.status==0){
                this.$message.error("机器人不在线!");
                return
            }
            if(obj.status==3){
                this.$message.error("机器人升级中,请稍后操作!");
                return
            }
           
            this.editRobotNo=obj.robotNo;
            let that=this
            this.$http.get('robot/uploadLog',{params :{ robotNo :  obj.robotNo }}) .then(response => {
               if (response.data.code === 200) {
                    this.dialogProgressVisible=true
                    let timeOut=0
                    that.timer = setInterval(() => {
                        if(timeOut > 13){
                            that.$message.error("上传超时!");
                            that.dialogProgressVisible=false
                            clearInterval(that.timer);
                        }
                        if(that.percentage < 90){
                            that.percentage=that.percentage+10
                        }      
                        timeOut=timeOut+1      
                    }, 1000);
               }else{
                    this.dialogProgressVisible=false
                    this.percentage=10
                    return this.$message.error(response.data.message);
               }
               
            })
        },
        //关闭进度框
        progressDialogClose(){
            this.dialogProgressVisible=false
            this.percentage=10
            clearInterval(this.timer);
            this.editRobotNo='';
        },
        progressTaskDialogClose(){
            this.progressStatus=null;
            this.dialogProgressTaskVisible=false;
            clearInterval(this.taskTimer);
            this.taskPercentage=10;
        },
        // //定时刷新
        localReload(){
            if(this.dialogTaskVisible!=true){
                console.log("刷新页面")
                location.reload()
            }
        },
        //升级
        upgrade(obj){
            if(obj.status==0){
                this.$message.error("机器人不在线!");
                return
            }
            if(obj.status==3){
                this.$message.error("机器人升级中,请稍后操作!");
                return
            }
            this.$http.get('robot/upgradeRobot',{params :{ hardwareNo :  obj.hardwareNo,robotNo :  obj.robotNo,version :  obj.version }}) .then(response => {
               if (response.data.code === 200) {
                  
                   return this.$message.success(response.data.message);
               }else{
                    return this.$message.error(response.data.message);
               }
               
            })
        },
      
        //添加任务
        addTaskItemClick(){
           if (this.addTask.type === '1') {
                console.log('标记', this.dotList)
                if(this.addTask.goalYaw==''){
                     this.doDraw(this.addTask.mapPngUrl)
                     return this.$message.error("请确定机器人行驶角度!")
                }
                if(this.addTask.goalName==''){
                     this.doDraw(this.addTask.mapPngUrl)
                     return this.$message.error("请输入起始点名称!")
                }
                if(this.addTask.taskList.length>0 && this.addTask.taskList[this.addTask.taskList.length-1].groupId==this.addTask.goalId){
                     this.doDraw(this.addTask.mapPngUrl)
                     return this.$message.error("添加任务重复,请选择其他点!")
                }
                //添加目标点 this.taskScene
                this.addTask.taskList.push({ robotNo: this.editRobotNo,mapId:this.taskScene.id, taskId: this.addTask.taskList.length + 1, goalName: this.addTask.goalName, 
                type: this.addTask.type, goalId: this.addTask.goalId, goalX: this.dotList[this.addTask.goalId].X, goalY: this.dotList[this.addTask.goalId].Y,
                goalYaw: this.addTask.goalYaw, command: 'start_stop', status: '1', voiceName: '--', workTime: '0' ,groupId : this.addTask.goalId})
                console.log(this.addTask.taskList)
                var len = this.addTask.taskList.length + 1;
                //添加行走
                this.addTask.taskList.push({ robotNo: this.editRobotNo,mapId:this.taskScene.id,
                taskId: len, goalName: this.addTask.goalName,type: '0', goalId: '-1', goalX: '0.000000', goalY: '0.000000',
                goalYaw: this.addTask.goalYaw, command: 'start_stop', status: '0', voiceName: '--', workTime: '0' ,groupId : this.addTask.goalId})
                this.addTask.goalName='';
                this.addTask.goalId='';
                this.addTask.goalYaw='';
                this.doDraw(this.addTask.mapPngUrl)
            } else if (this.addTask.type === '3') {
                if(this.addTask.taskList.length==0){
                    return this.$message.error("请先确认目标点!")
                }
                //获取上一个group
                var previousDate=this.addTask.taskList[this.addTask.taskList.length-1]
                if(previousDate.type!="0"){
                     return this.$message.error("请先确认目标点!")
                }
                if( this.addTask.taskSplitTime[this.addTask.timeId].label==undefined){
                     return this.$message.error("请输入任务时长!")
                }
                //添加消杀
                this.addTask.taskList.push({ robotNo: this.editRobotNo,mapId:this.taskScene.id, taskId: this.addTask.taskList.length + 1, 
                goalName: previousDate.goalName, type: this.addTask.type, goalId: '-1', goalX: '0.000000', goalY: '0.000000'
                , goalYaw: this.addTask.angle, command: 'start_stop', status: '1', voiceName: '--', workTime: this.addTask.taskSplitTime[this.addTask.timeId].label ,groupId : previousDate.groupId})
                this.addTask.timeId=''
            } 
        },
        //切换任务类型
        selectTaskType(val){
            if(val=='1'){
                this.addTask.showGoal=true;
                this.addTask.showMTime=false;
               
            }else{
                this.addTask.showMTime=true;
                this.addTask.showGoal=false;
               
            }
            this.addTask.showAddButton = true
            this.$forceUpdate()
        },
        deleteTaskClick(row){
            var tempTaskList=[];
            for (var i = 0; i < this.addTask.taskList.length; i++) {
                    if (this.addTask.taskList[i].groupId !== row.groupId) {
                        tempTaskList.push(this.addTask.taskList[i])
                    }
            }
            this.addTask.taskList=[];
            this.addTask.taskList=tempTaskList;
        },
        //任务编辑弹框
        taskDialog(obj){
                // if(obj.robotNo=='test000000000026'||obj.robotNo=='100110000220201222004150000500019'){
                //     this.tempRobot=obj;
                //     this.$http.get('/map/robotMapInfos',{params :{ robotNo : obj.robotNo }}).then(response => {
                //         if (response.data.code === 200) {
                //             this.dialogTaskVisible=true;
                //             this.editRobotNo=obj.robotNo;
                //             this.scenes=response.data.result;
                //             this.userMapNo=obj.scene
                //             console.log(this.scenes)
                //         }else{
                //                 return this.$message.error(response.data.message);
                //             }
                //         }).catch(failResponse => {
                //     })
                // }else{
                //     this.$router.replace({path: '/taskMap?robotNo='+obj.robotNo})
                // }
            this.$router.replace({path: '/robotManage?id='+obj.id})
        },
        clearCanvas(){
            var c=document.getElementById("mycanvas");
            var cxt=c.getContext("2d");
            cxt.clearRect(0,0,c.width,c.height);
        },
         // 下载原点文件
        downloadOFile(url) {
        console.log('下载原点文件', url)
         this.$http.get(window.location.origin+url)
            .then(res => {
                console.log(res)
                const blob = new Blob([res.data])
                const reader = new FileReader()
                const that = this
                reader.readAsText(blob, 'utf-8')
                reader.onload = function() {
                console.log(reader.result)
                that.resolution = reader.result.substring(reader.result.indexOf('resolution:') + 'resolution:'.length, reader.result.indexOf('origin:'))
                console.log("resolution "+that.resolution)
                var tempOrigin = reader.result.substring(reader.result.indexOf('[') + 1, reader.result.indexOf(']'))
                console.log(tempOrigin)
                var originArr = tempOrigin.split(',')
                that.origin_x = originArr[0]
                console.log("origin_x "+that.origin_x)
                that.origin_y = originArr[1]
                console.log("origin_y "+that.origin_y)
                that.doDraw(that.addTask.mapPngUrl)
            }  
            }).catch(res => {
                
            })
        },
        doDraw(imageUrl) {
            // 获取canvas
            var canvas = document.getElementById('mycanvas')
            var a = setInterval(() => {
                 // 重复获取
                canvas = document.getElementById('mycanvas')
                if (!canvas) {
                    return false
                } else {
                    clearInterval(a)
                    // 可以理解为一个画笔，可画路径、矩形、文字、图像
                    var context = canvas.getContext('2d')
                    var scale = window.devicePixelRatio
                    context.scale(scale, scale)
                    var img = new Image()
                    img.crossOrigin = '';
                    img.src = imageUrl
                    const that = this
                        // 加载图片
                    img.onload = function() {
                        if (img.complete) {
                            // 根据图像重新设定了canvas的长宽
                            canvas.setAttribute('width', img.width)
                            canvas.setAttribute('height', img.height)
                            that.imageWidth = canvas.width
                            that.imageHeight = canvas.height
                            that.gcanvas = canvas
                            // 绘制图片
                            context.drawImage(img, 0, 0, img.width, img.height)
                            var x1 = (0 - that.origin_x) / that.resolution
                            var y1 = that.imageHeight - (0 - that.origin_y) / that.resolution
                            that.doDrawLine(context, x1 - 10, y1, x1 + 10, y1, 'red', 2)
                            that.doDrawLine(context, x1, y1 - 10, x1, y1 + 10, 'red', 2)
                            that.downloadRoadFile(that.addTask.roadUrl)
                        }
                    }
                    var mousedown
                    canvas.onmousedown = function(ev) {
                        var rect = canvas.getBoundingClientRect()
                        var x = (ev.x - rect.left) * (canvas.width / rect.width)
                        var y = (ev.y - rect.top) * (canvas.height / rect.height)
                        //获取鼠标坐标
                        mousedown = { x, y }
                        //目标点归零
                        that.addTask.goalId = '-1'
                        //选走目标
                        if (that.addTask.type === '1') {
                            //查找xy点对应得坐标
                            that.findGoal(x, y)
                            //清除橡皮线
                            that.saveDrawingSurface(context)
                        }
                    }
                    //获取角度
                    canvas.onmousemove = function(ev) {
                        if (that.addTask.clickdown) {
                            var rect = canvas.getBoundingClientRect()
                            var x1 = (ev.x - rect.left) * (canvas.width / rect.width)
                            var y1 = (ev.y - rect.top) * (canvas.height / rect.height)
                            var loc = { x1, y1 }
                            //角度
                            that.addTask.angle = Math.atan2((y1 - mousedown.y), (x1 - mousedown.x))
                            //弧度
                            that.addTask.goalYaw = (that.addTask.angle / Math.PI * 180).toFixed(2)
                            that.restoreDrawingSurface(context)
                            that.drawingLine(context, loc, mousedown)
                        }
                    }
                    canvas.onmouseup = function(ev) {
                        that.addTask.clickdown = false
                    }
                }
            },1)
        },
        // 查找点击的目标点
        findGoal(x, y) {
            var that = this
            for (var i = 0; i < this.dotList.length; i++) {
                    var x1 = parseFloat(this.dotList[i].X)
                    var y1 = parseFloat(this.dotList[i].Y)
                    var gId = parseInt(this.dotList[i].Id)
                    x1 = (x1 - this.origin_x) / this.resolution
                    y1 = this.imageHeight - (y1 - this.origin_y) / this.resolution
                    if (Math.abs(x - x1) < 3 && Math.abs(y - y1) < 3) {
                        this.addTask.goalId = gId
                        that.addTask.clickdown = true
                        break
                    }
            }
        },
        // 绘图表面的保存与恢复
        saveDrawingSurface(context) {
            var that = this
            that.addTask.drawingSufraceData = context.getImageData(0, 0, this.imageWidth, this.imageHeight)
        },
        //
        restoreDrawingSurface(context) {
            var that = this
            context.putImageData(that.addTask.drawingSufraceData, 0, 0)
        },
        // 橡皮筋画线
        drawingLine(context, loc, ev) {
            context.beginPath()
            context.moveTo(ev.x, ev.y)
            context.lineTo(loc.x1, loc.y1)
            context.stroke()
        },
         //画轨迹
        downloadRoadFile(url) {
            console.log('画轨迹', url)
            this.$http.get(window.location.origin+url)
            .then(res => {
                    const blob = new Blob([res.data])
                    const reader = new FileReader()
                    const that = this
                    reader.readAsText(blob, 'utf-8')
                    reader.onload = function() {
                    var xmlList = reader.result.split('<vertex')
                    var lineXmlList = reader.result.split('<edge')
                    var tempList = []
                    var lineist = []
                    for (var i = 1; i < xmlList.length; i++) {
                         var tempString = xmlList[i]
                        if(tempString.indexOf("visible")== -1 ){
                            var Id = tempString.substring(tempString.indexOf('id="') + 4, tempString.indexOf('" x='))
                            var X = tempString.substring(tempString.indexOf('x="') + 3, tempString.indexOf('" y="'))
                            var Y = tempString.substring(tempString.indexOf('y="') + 3, tempString.indexOf('" yaw="'))
                            var name = tempString.substring(tempString.indexOf('Name="') + 6, tempString.indexOf('" />'))
                            tempList.push({ Id, X, Y })
                        }else{
                            var Id = tempString.substring(tempString.indexOf('id="') + 4, tempString.indexOf('" visible='))
                            var X = tempString.substring(tempString.indexOf('x="') + 3, tempString.indexOf('" y="'))
                            var Y = tempString.substring(tempString.indexOf('y="') + 3, tempString.indexOf('" />'))
                            tempList.push({ Id, X, Y })
                        } 
                    }
                    for (var k = 1; k < lineXmlList.length; k++) {
                        var lineString = lineXmlList[k]
                        var lid = lineString.substring(lineString.indexOf('id="') + 4, lineString.indexOf('" src_id='))
                        var src_id = lineString.substring(lineString.indexOf('src_id="') + 8, lineString.indexOf('" dst_id='))
                        var dst_id = lineString.substring(lineString.indexOf('dst_id="') + 8, lineString.indexOf('" directional='))
                        lineist.push({ lid, src_id, dst_id })
                    }
                    that.dotList = tempList
                    for (var j = 0; j < lineist.length; j++) {
                        var context = that.gcanvas.getContext('2d')
                        var scale = window.devicePixelRatio
                        context.scale(scale, scale)
                        var m = parseInt(lineist[j].src_id)
                        var n = parseInt(lineist[j].dst_id)
                        var x = parseFloat(that.dotList[m].X)
                        var y = parseFloat(that.dotList[m].Y)
                        x = (x - that.origin_x) / that.resolution
                        y = that.imageHeight - (y - that.origin_y) / that.resolution
                        var x2 = parseFloat(that.dotList[n].X)
                        var y2 = parseFloat(that.dotList[n].Y)
                        x2 = (x2 - that.origin_x) / that.resolution
                        y2 = that.imageHeight - (y2 - that.origin_y) / that.resolution
                        that.doDrawLine(context, x, y, x2, y2, 'blue', 2)
                    }
                    for (var l = 0; l < tempList.length; l++) {
                        var context1 = that.gcanvas.getContext('2d')
                        var scale1 = window.devicePixelRatio
                        context1.scale(scale1, scale1)
                        var x1 = parseFloat(that.dotList[l].X)
                        var y1 = parseFloat(that.dotList[l].Y)
                        x1 = (x1 - that.origin_x) / that.resolution
                        y1 = that.imageHeight - (y1 - that.origin_y) / that.resolution
                        that.doDrawSicle(context1, x1, y1, 'green', 3)
                    }
                }
            }).catch((error) => {
                console.log(error)
            })
        },
        // 画线doDra
        doDrawLine(context, x1, y1, x2, y2, color, line) {
            context.beginPath()
            context.moveTo(x1, y1)
            context.lineTo(x2, y2)
            context.strokeStyle = color
            context.lineWidth = line
            context.stroke()
        },
        // 画大圆点
        doDrawSicle(context, x, y, color, line) {
            context.beginPath()
            context.arc(x, y, line / 2, 2 * Math.PI, 0, true)
            context.lineWidth = line
            context.strokeStyle = color
            context.shadowOffsetX = 0
            context.shadowOffsetY = 0
            context.shadowColor = color
            context.shadowBlur = 0
            context.stroke()
        },
        
        //关闭任务弹框
        taskDialogClose(){
            this.dialogTaskVisible=false;
            this.addTask.taskList=[];
            this.addTask.gcanvas=null;
            this.clearCanvas()
            this.addTask.sceneSelected='';
            this.dialogPlanVisible=false;
            this.addPlan.planList=[];
            this.scenes=[];
            this.addPlan.sceneSelected='';
            this.addPlan.startAndend=[];
            this.addPlan.selectValueStr='';
            this.addPlan.selectTimeRange={};
            this.addPlan.textarea='';
            this.addPlan.type='';
            this.addPlan.showSplitTime=false;
            this.addPlan.showMTime=false;
            this.addPlan.labels=weekOptions;
            this.addPlan.checkAll=false;
            this.addPlan.isIndeterminate=false;
            this.addPlan.allElection=[];
            this.addPlan.selectionArr=[];
            this.addPlan.checkedWeekes='';
            this.addPlan.value='';
            this.addPlan.valueStr='';
            this.addPlan.timeIntervals=[];
            this.editRobotNo='';
            this.scene='';
        },
        //保存任务
        commitTaskClick(){
            if(this.scene == undefined || this.scene == null ||this.scene === ""){
                return this.$message.error("请选择要编辑的地图!");
            }
            this.$http.post('/task/addTask',JSON.stringify(this.addTask.taskList)) .then(response => {
                if (response.data.code === 200) {
                    this.$message.success(response.data.message);
                    this.dialogTaskVisible=false;
                    this.addTask.taskList=[];
                    this.addTask.sceneSelected='';
                    this.addTask.showGoal= false;
                    this.addTask.showMTime=false;
                    this.addTask.type='';
                    this.clearCanvas()
                }else{
                     return this.$message.error(response.data.message);
                }
                }).catch(failResponse => {

            })
        },
        usePlanAndTasks(){
            if(this.scene == undefined || this.scene == null ||this.scene === "" ){
                return  this.$message.error("请选择编辑地图!");
            }
            this.commitPlan();
            if( this.commitPlanFlag){
                return
            }
            if(this.addTask.taskList==null||this.addTask.taskList==undefined){
                return this.$message.error("请设置机器人任务!");
            }
            this.dialogProgressTaskVisible=true;
            this.newplan.tasks=this.addTask.taskList;
            let that=this
            this.$http.post('/plan/usePlanAndTasks',JSON.stringify(this.newplan)) .then(response => {
                if (response.data.code === 200) {
                    let timeOut=0
                    that.taskTimer = setInterval(() => {
                        if(timeOut > 15){
                            that.progressStatus="exception"
                            //this.$message.error("下发任务失败!");
                            var t
                            clearTimeout(t)
                            t = setTimeout(function() {
                               that.dialogProgressTaskVisible=false;
                               that.taskPercentage=10;
                               that.progressStatus=null
                            }, 2000)
                            clearInterval(that.taskTimer);
                            that.clearParams();
                        }
                        if(that.taskPercentage < 90){
                            that.taskPercentage=that.taskPercentage+10
                        }      
                        timeOut=timeOut+1      
                    }, 1000);
                    return
                }else{
                    this.dialogProgressTaskVisible=false
                    this.taskPercentage=10
                    return this.$message.error(response.data.message);
                }
                }).catch(failResponse => {
            })
        },
        commitPlanAndTaskClick(){
            if(this.scene == undefined || this.scene == null ||this.scene === "" ){
                return  this.$message.error("请选择编辑地图!");
            }
            this.commitPlan();
            if( this.commitPlanFlag){
                return
            }
            if(this.addTask.taskList==null||this.addTask.taskList==undefined){
                return this.$message.error("请设置机器人任务!");
            }
            this.newplan.tasks=this.addTask.taskList;
            this.$http.post('/plan/addPlanAndTasks',JSON.stringify(this.newplan)) .then(response => {
                if (response.data.code === 200) {
                   this.$message.success("保存成功!");
                   this.clearParams();
                   this.dialogTaskVisible=false;
                   return
                }else{
                     return this.$message.error(response.data.message);
                }
                }).catch(failResponse => {
            })
        },
        clearParams(){
                   // this.$message.success(response.data.message);
                    this.dialogPlanVisible=false;
                    this.addPlan.planList=[];
                    this.scenes=[];
                    this.addPlan.sceneSelected='';
                    this.addPlan.startAndend=[];
                    this.addPlan.selectValueStr='';
                    this.addPlan.selectTimeRange={};
                    this.addPlan.textarea='';
                    this.addPlan.type='';
                    this.addPlan.showSplitTime=false;
                    this.addPlan.showMTime=false;
                    this.addPlan.labels=weekOptions;
                    this.addPlan.checkAll=false;
                    this.addPlan.isIndeterminate=false;
                    this.addPlan.allElection=[];
                    this.addPlan.selectionArr=[];
                    this.addPlan.checkedWeekes='';
                    this.addPlan.value='';
                    this.addPlan.valueStr='';
                    this.addPlan.timeIntervals=[];
                    this.editRobotNo='';
                    this.scene='';
                    //this.$message.success(response.data.message);
                    this.dialogTaskVisible=false;
                    this.addTask.taskList=[];
                    this.addTask.sceneSelected='';
                    this.addTask.showGoal= false;
                    this.addTask.showMTime=false;
                    this.addTask.type='';
                    this.clearCanvas()
        },
        //提交计划
        commitPlan(){
            if(this.addPlan.planList!=null&&this.addPlan.planList.length>0){
                this.newplan.id=this.addPlan.planList[0].id;
            }
            this.newplan.robotNo=this.editRobotNo;
            if(this.scene==null){
                this.commitPlanFlag=true;
                return  this.$message.error("编辑地图信息错误!");
            }else{
                this.newplan.mapId=this.scene.id;
            }
            this.newplan.type=this.addPlan.type;
            this.newplan.startTime=this.addPlan.startAndend[0]
            this.newplan.endTime=this.addPlan.startAndend[1]
            let week =[];
            if(this.addPlan.checkedWeekes.length==0){
                this.commitPlanFlag=true;
                return this.$message.error("请选择星期!");
            }
            this.addPlan.checkedWeekes.forEach((obj)=>{
                if(obj=="星期一"){
                    week.push("1")
                }
                if(obj=="星期二"){
                    week.push("2")
                }
                if(obj=="星期三"){
                    week.push("3")
                }
                if(obj=="星期四"){
                    week.push("4")
                }
                if(obj=="星期五"){
                    week.push("5")
                }
                if(obj=="星期六"){
                    week.push("6")
                }
                if(obj=="星期天"){
                    week.push("7")
                }
            })
            this.newplan.week=week.join(",");
            let scenes=this.scenes
            let that=this;
            scenes.forEach((obj)=>{
                if(obj.id==that.newplan.mapId){
                   console.log(obj.id+" ;"+that.newplan.mapId)
                   obj.tasks=that.addTask.taskList;
                   obj.plan={type:'',week:'',plan:''}
                   obj.plan.type=that.addPlan.type;
                   obj.plan.week=that.newplan.week;
                   if(that.addPlan.type=="1"){
                      obj.plan.value=that.addPlan.timeId
                   }else{
                      obj.plan.value=that.addPlan.valueStr;
                   }
                   that.addPlan.selectValueStr=''
                   that.addTask.showGoal= false;
                   that.addTask.showMTime=false;
                   that.addTask.type='';
                }

            });
            if(this.addPlan.type==1){
                this.newplan.value=this.addPlan.timeId
            }else{
               this.newplan.value=this.addPlan.valueStr
            }
        },
        //设置时间段的起始时间
        changestartAndend(val){
            this.addPlan.startAndend = val
            var tempStamp = val[0] + ":00"+'-' + val[1]+ ":00"
            this.addPlan.selectTimeRange = { selectableRange: tempStamp }
            console.log(this.addPlan.selectTimeRange);
        },
        //删除时间段
        reduceTimeClick(){
            if (this.addPlan.timeIntervals.length > 0) {
                this.addPlan.timeIntervals.pop()
                this.setTimeInterval()
            }
        },
        //添加时间段
        addTimeClick(){
            //剔除重复的时间
            if (this.addPlan.selectValueStr !== null && this.addPlan.selectValueStr.split(' ').join('').length !== 0) {
                    for (var i = 0; i < this.addPlan.timeIntervals.length; i++) {
                    if (this.addPlan.timeIntervals[i] === this.addPlan.selectValueStr) {
                        this.addPlan.timeIntervals.splice(i, 1)
                    }
                }
                this.addPlan.timeIntervals.push(this.addPlan.selectValueStr)
                this.setTimeInterval()
            }
        },
        // 拼接时间段值
        setTimeInterval() {
        this.addPlan.valueStr = ''
            for (var i = 0; i < this.addPlan.timeIntervals.length; i++) {
                if (i < this.addPlan.timeIntervals.length - 1) {
                    this.addPlan.valueStr = this.addPlan.valueStr + this.addPlan.timeIntervals[i] + ','
                } else {
                    this.addPlan.valueStr = this.addPlan.valueStr + this.addPlan.timeIntervals[i]
                }
            }
        },
        // 获取选中的对象
        selectionFun(selectionArr) { 
            this.addPlan.selectionArr = []
            for (var i = 0; i < this.addPlan.labels.length; i++) {
                for (var j = 0; j < selectionArr.length; j++) {
                    if (selectionArr[j] === this.addPlan.labels[i]) {
                        this.addPlan.selectionArr.push(this.addPlan.labels[i])
                    }
                }
            }
            console.log( this.addPlan.selectionArr)
        },
        allElectionFun() { // 全选数组
            this.addPlan.allElection = []
            for (var i = 0; i < this.addPlan.labels.length; i++) {
                this.addPlan.allElection.push(this.addPlan.labels[i])
            }
        },
        //全选周期
        handleCheckAllChange(val){
            this.allElectionFun()
            this.addPlan.checkedWeekes = val ? this.addPlan.allElection : []
            this.addPlan.isIndeterminate = false
            this.selectionFun(this.addPlan.checkedWeekes)
        },
        handleCheckedWeekesChange(val) { // 选中
            const checkedCount = val.length
            this.addPlan.checkAll = checkedCount === this.addPlan.labels.length
            this.addPlan.isIndeterminate = checkedCount > 0 && checkedCount < this.addPlan.labels.length
            this.selectionFun(val)
        },
        // 场景选择
        changeSceneSelected(val) {
            let scenes=this.scenes
            if(scenes.length>0){
                scenes.forEach((obj)=>{
                    if(obj.id==val){
                       this.scene=obj
                       if(obj.plan==null){
                            this.addPlan.planList=[];
                            this.addPlan.checkedWeekes=[];
                            this.addPlan.startAndend=["00:00:00","23:59:59"];
                            this.addPlan.type='';
                            this.addPlan.timeId='';
                            this.addPlan.valueStr='';
                            this.addPlan.showSplitTime = false
                            this.addPlan.showMTime = false
                       }else{
                            if(this.addPlan.planList.length>0){
                                this.addPlan.planList=[]
                            }
                            this.addPlan.planList.push(obj.plan) ;
                            if(this.addPlan.startAndend.length>0){
                                this.addPlan.startAndend=[]
                            }
                            this.addPlan.startAndend.push(obj.plan.startTime);
                            this.addPlan.startAndend.push(obj.plan.endTime);
                            console.log(this.addPlan.startAndend);
                            this.addPlan.type=obj.plan.type;
                            if(this.addPlan.type==1){
                                this.addPlan.timeId=obj.plan.value;
                                this.addPlan.showSplitTime = true
                                this.addPlan.showMTime = false
                            }else{
                                this.addPlan.showSplitTime = false
                                this.addPlan.showMTime = true
                                this.addPlan.valueStr=obj.plan.value;
                                this.addPlan.timeIntervals=[];
                                let timeIntervals=obj.plan.value.split(",");
                                this.addPlan.timeIntervals=timeIntervals
                            }
                            console.log(this.addPlan.startAndend);
                            let week=obj.plan.week;
                            let newweek=week.split(',')
                            let weeks=[]
                            newweek.forEach(function(item, index) {
                                if(item==1){
                                    weeks.push('星期一')
                                }
                                if(item==2){
                                    weeks.push('星期二')
                                }
                                if(item==3){
                                    weeks.push('星期三')
                                }
                                if(item==4){
                                    weeks.push('星期四')
                                }
                                if(item==5){
                                    weeks.push('星期五')
                                }
                                if(item==6){
                                    weeks.push('星期六')
                                }
                                if(item==7){
                                    weeks.push('星期天')
                                }
                            })
                          this.addPlan.checkedWeekes=weeks;
                       }
                    }
                })
            }
            if(scenes.length>0){
                scenes.forEach((obj)=>{
                    if(obj.id==val){
                        this.taskScene=obj
                        if(obj.tasks!=null){
                            this.addTask.taskList=obj.tasks
                            this.addTask.gcanvas=null;
                            this.clearCanvas()

                        }else{
                            this.addTask.taskList=[]
                           
                        }
                        //加载地图
                        this.addTask.mapPngUrl=obj.mapPngUrl;
                        this.addTask.roadUrl=obj.roadUrl;
                        this.addTask.orginUrl=obj.orginUrl;
                        this.downloadOFile(this.addTask.orginUrl);
                    }
                    

                })
            }
           
        },
        //切换计划类型
        selectplanType(val){
             if (val === '1') {
                this.addPlan.showSplitTime = true
                this.addPlan.showMTime = false
                this.addPlan.selectTimeRange = {}
                this.addPlan.valueStr='';
                this.addPlan.selectValueStr='';
                this.addPlan.timeId='';
            } else if(val === '2') {
                let tempStamp 
                if(this.addPlan.planList.length==0 ){
                    tempStamp = "00:00:00"+ '-' +"23:59:59";
                }else{
                     tempStamp = this.addPlan.planList[0].startTime+":00" + '-' + this.addPlan.planList[0].endTime+":00";
                }
                this.addPlan.selectTimeRange = { selectableRange: tempStamp }
                this.addPlan.showSplitTime = false
                this.addPlan.showMTime = true
                this.addPlan.value='';
            }
           // this.$forceUpdate()
        },
        //计划编辑弹框
        planDialog(obj){
               this.dialogPlanVisible=true;
               this.$http.get('/map/robotMapInfo',{params :{ robotNo : obj.robotNo }})
               .then(response => {
                        if (response.data.code === 200) {
                            this.editRobotNo=obj.robotNo;
                            this.scenes=response.data.result;
                            console.log(this.scenes)
                        }else{
                            return this.$message.error(response.data.message);
                        }
                    }).catch(failResponse => {

              })
        },
        //点击指定页码跳转
        handleCurrentChange(page){
            this.robotInfo.pageNum=page;
            this.searchRobot();
        },
        clearParamsRobotInfo(){
          this.robotInfo.robotNo='';
          this.robotInfo.robotName='';
          this.robotInfo.status='';
          this.robotInfo.robotType='';
        },
        searchRobot(){
            var check = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/
            if(check.test(this.robotInfo.robotNo)||check.test(this.robotInfo.robotNo)){
                return this.$message.error("请输入非特殊字符!");
            }
            this.$http.post('/robot/selectRobots',JSON.stringify(this.robotInfo))
            .then(response => {
                    if (response.data.code === 200) {
                        this.robotList=response.data.result.data
                        this.total=response.data.result.total
                    }else{
                        return this.$message.error(response.data.message);
                    }
                }).catch(failResponse => {

            })
        },
  }
  
}
</script>

<style lang="less" scoped>
.el-input {
    width: 150px;
}
.ell-input {
    width: 200px;
}
.elll-input {
    width: 150px;
}
.m-l-30 {
  margin-left: 30px !important;
}

.m-l-20 {
  margin-left: 0px !important;
}

.el-row {
    margin-bottom: 10px;
}

.ell-row {
    margin-bottom: 40px;
    display: flex;
    flex-wrap: wrap
}
html,body,.XSDFXPage{
        width: 50%;
        height: 50%;
        overflow: hidden;
        margin: 0px auto;
        font-family: "微软雅黑";
}
.map {
        width: 100%;
        height: 400px;
}

.dialog1 {
    font-weight: bold;
    align-content: center;
    margin:auto;
}
 
</style>


// WEBPACK FOOTER //
// src/components/robot/MissionPlanning.vue